module.exports = __webpack_public_path__ + "static/media/province50.ad2af3de.png";